export default {
  token: {
    data: {
      'key': 'azertyuiop'
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/test-api/datas/auth.data.js